module.exports = __webpack_public_path__ + "static/media/snapscan.3ee8561e.svg";